module.exports = __webpack_public_path__ + "fonts/fa-light-300.d8e14023.woff";